import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { t } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import { Grid, Stack, Tooltip } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

import InfoSection from '@/components/ui/sections/InfoSection'
import TextInputController from '@/components/ui/inputs/TextInputController'
import { useIsUS } from '@/hooks/useIsUS'

import { PatientProfileFormData } from '../model/usePatientProfileForm'

export function BillingInfoSection({ editable }: { editable: boolean }) {
  useLingui()
  const i18next = useTranslation()
  const isUS = useIsUS()
  const rhForm = useFormContext<PatientProfileFormData>()
  return (
    <InfoSection label={t`Billing information`}>
      <Grid container spacing={3} sx={{ mt: '0px' }}>
        <Grid item xs={12} md={6}>
          {isUS ? (
            <TextInputController
              control={rhForm.control}
              fullWidth
              label={
                <Stack direction="row" alignItems="center" spacing={1}>
                  <span>{i18next.t('field.insured.label')}</span>
                  <Tooltip placement="top" title={t`if different from the patient name`}>
                    <InfoOutlinedIcon fontSize="small" />
                  </Tooltip>
                </Stack>
              }
              name="insured"
            />
          ) : (
            <TextInputController control={rhForm.control} fullWidth label={t`SSN Gestion Code`} name="codeGestion" readOnly={!editable} />
          )}
        </Grid>
        <Grid item xs={12} md={6}>
          {isUS ? (
            <TextInputController
              control={rhForm.control}
              fullWidth
              label={i18next.t('field.insuredRelationship.label')}
              name="insuredRelationship"
              readOnly={!editable}
            />
          ) : (
            <TextInputController control={rhForm.control} fullWidth label={t`SSN Caisse`} name="caisse" readOnly={!editable} />
          )}
        </Grid>
        <Grid item xs={12} md={6}>
          {isUS ? (
            <TextInputController
              control={rhForm.control}
              fullWidth
              label={i18next.t('field.primaryInsurance.label')}
              name="primaryInsurance"
              readOnly={!editable}
            />
          ) : (
            <TextInputController control={rhForm.control} fullWidth label={t`SSN Regime Code`} name="codeRegime" readOnly={!editable} />
          )}
        </Grid>
        {isUS && (
          <Grid item xs={12} md={6}>
            <TextInputController
              control={rhForm.control}
              fullWidth
              label={i18next.t('field.secondaryInsurance.label')}
              name="secondaryInsurance"
              readOnly={!editable}
            />
          </Grid>
        )}
      </Grid>
    </InfoSection>
  )
}
